export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID de Tabless',
      placeholder: 'ID interno en el sistema Tabless',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Cambios guardados',
  },
  connected: {
    title: 'Tabless está conectado',
    description: 'Esta integración está configurada.',
  },
};
